import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/report',
  component: () => import('@views/Report/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'report.index',
      component: () => import('@/components/Report/Report'),
    },
  ]
}